export const baseSurveyJson = {
    locale: "en",
    title: {
        en: "ePreop Patient Experience Survey NEW"
    },
    completedHtml: "Thank you for taking the time to fill out the survey.  Your feedback is very important to us.",
    loadingHtml: {
        en: "Please wait while the survey loads..."
    },
    sendResultOnPageNext: true,
    showPrevButton: true,
    showTitle: false,
    showPageTitles: false,
    showQuestionNumbers: "off",
    showProgressBar: true,
    progressBarLocation: "bottom",
    autoAdvanceEnabled: true,
    autoAdvanceAllowComplete: false,
    widthMode: "responsive"
}

export const surveyCss = {
    radiogroup: {
        root: "sd-selectbase ",
        rootMobile: "sd-selectbase--mobile",
        rootRow: "sd-selectbase--row",
        rootMultiColumn: "sd-selectbase--multi-column",
        item: "sd-item sd-radio sd-selectbase__item radio-element d-grid gap-2",
        itemOnError: "sd-item--error",
        itemInline: "sd-selectbase__item--inline",
        label: "sd-selectbase__label element-animation1 btn btn-lg btn-primary",
        labelChecked: "",
        itemEnter: "sd-item--enter",
        itemLeave: "sd-item--leave",
        itemDisabled: "sd-item--disabled sd-radio--disabled",
        itemReadOnly: "sd-item--readonly sd-radio--readonly",
        itemPreview: "sd-item--preview sd-radio--preview",
        itemPreviewSvgIconId: "#icon-check-16x16",
        itemChecked: "sd-item--checked sd-radio--checked",
        itemHover: "sd-item--allowhover sd-radio--allowhover",
        itemControl: "sd-visuallyhidden sd-item__control sd-radio__control",
        itemDecorator: "sd-item__svg sd-radio__svg",
        controlLabel: "sd-item__control-label radio-element-label",
        materialDecorator: "sd-item__decorator sd-radio__decorator",
        other: "sd-input sd-comment sd-selectbase__other",
        clearButton: "",
        column: "sd-selectbase__column"
    },
}
